export default {"src":"/_next/static/media/SubDesc2.4d1a5605.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};